import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Paper,
  Button,
  IconButton,
  Typography,
  Box,
  Menu,
  MenuItem,
  Pagination,
  PaginationItem,
  Drawer,
  Alert,
  Snackbar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AddVendorMaster from "./AddVendorMaster";
import UserDateFilter from "../../Roles and Permissions/Filters/UserFilters/UserDateFilter";
import { api, get } from "../../../../utils/api";
import FilterSidebar from "../../../../Components/Masters/Filter/FilterSidebar";
import ApplyButton from "../../Roles and Permissions/Filters/ApplyButton";
import ResetButton from "../../Roles and Permissions/Filters/ResetButton";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { styled } from "@mui/material/styles";
import ViewVendor from "./ViewVendorMaster";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import DeleteDialog from "../../../../Components/Masters/DeleteDialog";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import MastersSidebar from "../../../../Layout/MastersSidebar";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";
import DateRangePickerComponent from "../../Roles and Permissions/Filters/Date";
import TopMenu from "../../../../Components/Masters/TopMenu";
import MenuIcon from "../../../../Components/Masters/MenuIcon";
import ColumnHeadings from "../../../../Components/Masters/ColumnHeadings";
import {FacilityColumnHeading,
  facilityDataCellSx,
  getFacilityName,
  getVendorMasterColumnWidth,
  getVendorMasterHeaderRowSx,
  getGridTableRowSx,
  gridTableActionHeaderSx,
  gridTablePaperSx,
  masterDateDataCellSx,
  shouldShowFacilityColumn, FacilityDataCell, MasterDateDataCell } from "../../../../utils/facilityColumn";

const VendorMaster = () => {
  const { user } = useUser();
  const showFacilityColumn = shouldShowFacilityColumn(user);
  const columnWidth = getVendorMasterColumnWidth(showFacilityColumn);

  const [vendors, setVendors] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addVendor, setAddVendor] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
  });
  const [viewVendor, setViewVendor] = useState(false);
  const [dataView, setdataView] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedCountries, setSelectedCountries] = useState([]); // Store selected countries

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [errors, setErrors] = useState({
    Date: false,
  });

  const filters = ["Date"];
  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
  });

  const facilityData = [
    { header: "Date", field: "createdAt" },
    // { header: "Facility Name", field: "facilityName" },
    { header: "Brand", field: "brand" },
    // { header: "Outsource Facility", field: "outsourceFacility" },
    { header: "Country", field: "country" },
    // { header: "Action" },
  ];
  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            url={`${api}/master/Steam/getVendor`}
            startDate={tempFilter.startDate}
            endDate={tempFilter.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
            errors={errors.Date}
          />
        );
      default:
        return null;
    }
  };

  const handleMenuClick = (event, vendor) => {
    setAnchorEl(event.currentTarget);
    setSelectedVendor(vendor);
    setdataView(vendor);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedVendor(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddVendor(true);
    setViewVendor(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewVendor(true);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // fetching  data
  const fetchSteamVendor = async (filters = filtersToApply) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        limit: rowsPerPage,
        sortField: sortConfig.key,
        sortOrder: sortConfig.direction,
      }).toString();
      const response = await get(
        `${api}/master/Steam/getVendor?${queryParams}`
      );

      setVendors(response.data.data);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchSteamVendor();
  }, [page, rowsPerPage, sortConfig]);

  // default filters to apply
  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
  };
  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = { Date: "", Facility: "", Country: "" };
    if (selectedFilter === "Date") {
      if (startDate > endDate) {
        newErrors.Date = "End date must be greater than Start date";
        isValid = false;
      }
      // if (!startDate && !endDate) {
      //   newErrors.Date = "Please select a date range";
      //   isValid = false;
      // }
    }
    setErrors(newErrors);
    return isValid;
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    if (!validateFilters()) return;

    // fetchSteamVendor();
    fetchSteamVendor(filtersToApply);
    setPage(1);
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    setDrawerFilterOpen(false);
    handleAppliedFilters();
  };

  // Applying reset filters
  const handleResetFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setTempFilter({ startDate: null, endDate: null });
    setAppliedFilters({});
    setIsFiltersApplied(false);
    fetchSteamVendor({});
    setErrors({});
    setDrawerFilterOpen(false);
  };

  // handle the applied filters for styling
  const handleAppliedFilters = () => {
    // Use tempFilter's current state to determine applied filters
    const isDateApplied = tempFilter.startDate || tempFilter.endDate;
    setIsFiltersApplied(isDateApplied);
    setAppliedFilters({ Date: isDateApplied });
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const getManualWidth = (header) => {
    switch (header) {
      case "Date":
        return "12%";
      case "FacilityName":
        return "22%";
      case "Incharge":
        return "20%";
      case "Outsource Facility":
        return "15%";
      case "Country":
        return "21%";
      case "Action":
        return "10%";
      default:
        return "auto"; // default width if header doesn't match
    }
  };

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
    });
    setDrawerFilterOpen(false);
    setErrors({ Date: false, Role: false });
  };

  return (
    <MainDashboardLayout sidebar={<MastersSidebar />}>
      <Unauthorized requiredModule="Setup | Master">
        <Box
          sx={{
            backgroundColor: "#ededed",
          }}
        >
          <Snackbar
            open={snackOpen.open}
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={() => setsnackOpen({ ...snackOpen, open: false })}
          >
            <Alert
              // onClose={handleClose}
              severity={snackOpen.severity}
              variant="filled"
              sx={{ width: "100%" }}
            >
              {snackOpen.message}
              {/* Add user Successfully */}
            </Alert>
          </Snackbar>
          <AddVendorMaster
            addVendor={addVendor}
            setAddVendor={setAddVendor}
            fetchSteamVendor={fetchSteamVendor}
            setsnackOpen={setsnackOpen}
            //  addFacility={addFacility}
            selectedVendor={dataView}
          />
          <ViewVendor
            viewVendor={viewVendor}
            setViewVendor={setViewVendor}
            selectedVendor={dataView}
            handleEdit={handleEdit}
          />
          {/* {deleteDialog && (
          <DeleteDialog
            {...{ deleteDialog, setDeleteDialog, handleDeleteAggree }}
          />
        )} */}
          <DeleteDialog
            {...{
              deleteDialog,
              setDeleteDialog,
              id: dataView?._id,
              url: `${api}/master/Steam/DeleteVendor`,
              setsnackOpen,
              fetchData: fetchSteamVendor,
            }}
          />
          {/* <Toolbar sx={{ padding: "0 16px", marginBottom: "20px" }}> */}
          {drawerFilterOpen && (
            <Drawer
              anchor="right"
              open={drawerFilterOpen}
              onClose={() => handleFilterDrawer()}
              sx={{
                backgroundColor: "transparent",
                "& .MuiDrawer-paper": {
                  // This targets the paper component within the Drawer
                  backgroundColor: "transparent", // Make paper transparent
                  boxShadow: "none", // Optional: Remove any shadow
                  width: "50%",
                },
              }}
            >
              <Box
                display="flex"
                gap={3}
                sx={{
                  width: "100%",
                  display: "flex",
                  overflowX: "hidden",
                  maxWidth: "100%",
                  justifyContent: "space-btween",
                  height: "100%",
                  backgroundColor: "transparent",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#f5f5f5",
                    height: "3%",
                    padding: "13px",
                    margin: "30px 0 0 0",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "80%",
                    width: "3%",
                  }}
                >
                  <IconButton
                    onClick={() => setDrawerFilterOpen(false)}
                    sx={{ color: "black" }}
                  >
                    <CloseIcon sx={{ fontSize: "1.2rem" }} />
                  </IconButton>
                </Box>
                <Box sx={{ display: "flex", width: "100%", height: "100vh" }}>
                  {/* Sidebar for selecting the filter */}
                  <FilterSidebar
                    {...{
                      setSelectedFilter,
                      selectedFilter,
                      filters,
                      appliedFilters,
                    }}
                  />

                  {/* Filter content area */}
                  <Box
                    sx={{
                      flexGrow: 1,
                      backgroundColor: "#F9F9F9",
                      padding: "20px",
                    }}
                  >
                    {renderSelectedFilter()}
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        gap: "3%",
                        position: "fixed",
                        bottom: "20px",
                        ml: 3,
                        mr: 3,
                      }}
                    >
                      <ApplyButton handleApply={handleApplyFilters} />
                      <ResetButton handleReset={handleResetFilters} />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Drawer>
          )}{" "}
          {/* <Box
            sx={{
              pt: "2rem",
              // display: "flex",
              justifyContent: "space-between",
              width: !user?.companyAdmin ? "96%" : "100%",
              marginRight: "1.5%",
              // justifyContent: "flex-end",
              // ml: "20%",
            }}
          >
            <Box item xs={6} sx={{ paddingLeft: 0, display: "flex" }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  // margin: "0px 0px 20px 0px",
                  textDecoration: "underline",
                  // paddingLeft: "20px",
                  // paddingTop: "10px",
                }}
              >
                Scope2
              </Typography>
            </Box>
            <Box item xs={6} sx={{ textAlign: "right", margin: "1rem 0.2rem" }}>
              <Button
                variant="contained"
                // onClick={() => setDrawerFilterOpen(true)}
                onClick={() => {
                  setTempFilter({
                    startDate: startDate,
                    endDate: endDate,
                  });
                  setDrawerFilterOpen(true);
                }}
                // endIcon={<FilterListIcon />}
                sx={{
                  // margin: "10px 10px 5px 0px",
                  margin: !user?.companyAdmin ? "0px 10px 0px 0px" : "0px",
                  backgroundColor: "#ffffff",
                  color: "black",
                  "&:hover": { backgroundColor: "#1c486b", color: "#FFFFFF" },
                  "&:hover .dot-icon": {
                    color: "#FFFFFF", // Change dot color on button hover
                  },
                  // display:"flex"
                }}
              >
                Filter
                <FilterListIcon />
                {(tempFilter?.startDate || tempFilter?.endDate) && (
                  <FiberManualRecordIcon
                    className="dot-icon"
                    sx={{
                      fontSize: "10px",
                      color: "#488257",
                      marginLeft: "5px",
                    }}
                  />
                )}
              </Button>
              {!user?.companyAdmin && (
                <Button
                  variant="contained"
                  endIcon={<AddIcon />}
                  sx={{
                    margin: "10px -36px 8px 0px",
                    backgroundColor: "#1c486b",
                    fontSize: "14px",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    setAddVendor(true);
                    setdataView(null);
                  }}
                >
                  Add New
                </Button>
              )}
            </Box>
          </Box> */}
          <TopMenu
            setData={setdataView}
            setAddData={setAddVendor}
            onClick={() => {
              setTempFilter({
                startDate: startDate,
                endDate: endDate,
              });
              setDrawerFilterOpen(true);
            }}
            {...{
              heading: "Scope 2",
              setDrawerFilterOpen,
              filterApplied: tempFilter?.startDate || tempFilter?.endDate,
            }}
          />
          {/* </Toolbar> */}
          <TableContainer
            component={Paper}
            sx={{ ...gridTablePaperSx, flex: 1, overflowX: "hidden" }}
          >
            <Box>
              <Box sx={{ margin: "16px" }}>
                <Box
                  sx={{
                    fontWeight: "bold",
                    fontSize: "20px",
                    textAlign: "left",
                    // padding: "0px",
                  }}
                >
                  Steam Vendor Master
                </Box>
              </Box>
              <Box sx={getVendorMasterHeaderRowSx(columnWidth)}>
                <ColumnHeadings
                  title="Date"
                  key="Date"
                  handleSort={handleSort}
                  field="createdAt"
                  sortConfig={sortConfig}
                />
                {showFacilityColumn && (
                  <FacilityColumnHeading
                    handleSort={handleSort}
                    sortConfig={sortConfig}
                  />
                )}
                <ColumnHeadings
                  title="Vendor Legal Full Name"
                  key="Vendor Legal Full Name"
                  handleSort={handleSort}
                  field="VendorLegalFullName"
                  sortConfig={sortConfig}
                />
                <Typography sx={gridTableActionHeaderSx}>Action</Typography>
              </Box>
              {vendors.length === 0 ? (
                <NoDataFound />
              ) : (
                vendors.map((vendors) => (
                  <Box
                    key={vendors._id}
                    sx={{
                      ...getGridTableRowSx(columnWidth),
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <MasterDateDataCell>
                      {new Date(vendors.createdAt).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </MasterDateDataCell>
                    {showFacilityColumn && (
                      <FacilityDataCell>
                        {getFacilityName(vendors) || "N/A"}
                      </FacilityDataCell>
                    )}
                    <FacilityDataCell>
                      {vendors.VendorLegalFullName}
                    </FacilityDataCell>

                    <MenuIcon handleMenuClick={handleMenuClick} field={vendors} />
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* </TableContainer> */}
          {/* Pagination */}
          {totalPages > 1 && (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mt: 3,
                  backgroundColor: "#ffffff",
                  width: "100%",
                  borderRadius: "2%",
                  padding: "4px",
                  marginBottom: "1rem",
                }}
              >
                <Pagination
                  count={totalPages}
                  page={page}
                  onChange={handleChangePage}
                  renderItem={(item) => (
                    <StyledPaginationItem
                      // <PaginationItem
                      {...item}
                      components={{
                        previous: () => (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mr: 27,
                            }}
                          >
                            <ArrowBackIcon sx={{ mr: 0.5, color: "green" }} />
                            Previous
                          </Box>
                        ),
                        next: () => (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              ml: 27,
                            }}
                          >
                            Next
                            <ArrowForwardIcon
                              sx={{ ml: 0.5, color: "green" }}
                            />
                          </Box>
                        ),
                      }}
                      sx={{
                        "& .MuiPaginationItem-root": {
                          mx: 1,
                        },
                        "& .MuiPagination-ul": {
                          display: "flex",
                          alignItems: "center",
                        },
                      }}
                    />
                  )}
                />
              </Box>
            </Box>
          )}
          {/* Menu for Actions */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            PaperProps={{
              sx: {
                width: "120px",
                border: "1px solid #ddd",
                marginLeft: "-47px",
              },
            }}
          >
            {user?.companyAdmin ? (
              <>
                <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
                  <AssignmentIcon
                    sx={{ marginRight: "8px", fontSize: "large" }}
                  />
                  View Logs
                </MenuItem>
              </>
            ) : (
              <>
                <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
                  <AssignmentIcon
                    sx={{ marginRight: "8px", fontSize: "large" }}
                  />
                  View Logs
                </MenuItem>
                <MenuItem onClick={handleEdit} sx={{ fontSize: "14px" }}>
                  <EditIcon sx={{ marginRight: "8px", fontSize: "large" }} />{" "}
                  Edit
                </MenuItem>
                <MenuItem onClick={handleDelete} sx={{ fontSize: "14px" }}>
                  <DeleteIcon sx={{ marginRight: "8px", fontSize: "large" }} />{" "}
                  Delete
                </MenuItem>
              </>
            )}
          </Menu>
        </Box>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default VendorMaster;
